const translations = {
  pt: {
    appSubtitle: "Analise Desportiva", navFixtures: "Jogos", navBankroll: "Banca",
    btnRefresh: "Atualizar dados", btnSuggestions: "Sugestoes", btnLogin: "Entrar", btnLogout: "Sair",
    topTips: "Top Tips do Dia", noTips: "Sem tips de alta confianca hoje. Volta amanha.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets do Dia", noValueBets: "Sem value bets para hoje",
    noValueBetsSubtitle: "Volta mais tarde ou amanha", loadingGames: "A carregar jogos...", loading: "A carregar...",
    noGames: "Sem jogos para este dia", noGamesDay: "Sem jogos para este dia",
    result: "Resultado", homeWin: "Vitoria Casa", draw: "Empate", awayWin: "Vitoria Fora",
    goals: "Golos", over25: "Mais 2.5", under25: "Menos 2.5", btts: "Ambas Marcam", bttsShort: "BTTS Sim",
    corners: "Cantos", totalExpected: "Total Esperado",
    model: "Modelo", version: "Versao", league: "Liga", threshold: "Threshold", bankroll: "Banca",
    marketAnalysis: "Analise de Mercado", valueBetsSection: "Value Bets", standings: "Tabela",
    prediction: "Previsao", events: "Eventos", statistics: "Estatisticas", lineups: "Onzes",
    expectedGoals: "Golos Esperados", terms: "Termos", privacy: "Privacidade", refund: "Reembolso",
    competitions: "Competicoes", suggestions: "Sugestoes", subscribePremium: "Assinar Premium", subscribePrice: "$9.99/mes",
    selectLeague: "Selecionar Liga", back: "Voltar", live: "AO VIVO",
    watchAd: "Assistir Anuncio para Desbloquear",
    rank: "Pos", team: "Equipa", played: "J", wins: "V", draws: "E", losses: "D", goalDiff: "DG", points: "Pts", form: "Forma",
    homeWinFull: "Vitoria Casa", drawFull: "Empate", awayWinFull: "Vitoria Fora",
    over25Full: "Mais de 2.5 Golos", under25Full: "Menos de 2.5 Golos",
    bttsYes: "Ambas Marcam - Sim", bttsNo: "Ambas Marcam - Nao",
    cornersOver: "Cantos Mais de", edgeLabel: "Edge", oddLabel: "Odd", probLabel: "Prob",
    stakeLabel: "Aposta", valueBetLabel: "VALUE BET", redFlagLabel: "RISCO ALTO",
    leaguesCat: "Ligas Nacionais", europeCat: "Competicoes Europeias", cupsCat: "Tacas Nacionais", internationalCat: "Selecoes",
    matchEvents: "Eventos do Jogo", noEvents: "Sem eventos ainda",
    starters: "Titular", substitutes: "Suplentes",
    homeLabel: "Casa", awayLabel: "Fora",
    cornersLabel: "Cantos", goalsLabel: "Golos", resultLabel: "Resultado", modelLabel: "Modelo",
    home1: "1 - Casa", drawX: "X - Empate", away2: "2 - Fora",
    over85c: "> 8.5 Cantos", over95c: "> 9.5 Cantos", over105c: "> 10.5 Cantos",
  },
  "pt-BR": {
    appSubtitle: "Analise Esportiva", navFixtures: "Jogos", navBankroll: "Banca",
    btnRefresh: "Atualizar dados", btnSuggestions: "Sugestoes", btnLogin: "Entrar", btnLogout: "Sair",
    topTips: "Top Tips do Dia", noTips: "Sem tips de alta confianca hoje. Volte amanha.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets do Dia", noValueBets: "Sem value bets para hoje",
    noValueBetsSubtitle: "Volte mais tarde ou amanha", loadingGames: "Carregando jogos...", loading: "Carregando...",
    noGames: "Sem jogos para este dia", noGamesDay: "Sem jogos para este dia",
    result: "Resultado", homeWin: "Vitoria Casa", draw: "Empate", awayWin: "Vitoria Fora",
    goals: "Gols", over25: "Mais 2.5", under25: "Menos 2.5", btts: "Ambas Marcam", bttsShort: "BTTS Sim",
    corners: "Escanteios", totalExpected: "Total Esperado",
    model: "Modelo", version: "Versao", league: "Liga", threshold: "Threshold", bankroll: "Banca",
    marketAnalysis: "Analise de Mercado", valueBetsSection: "Value Bets", standings: "Tabela",
    prediction: "Previsao", events: "Eventos", statistics: "Estatisticas", lineups: "Escalacoes",
    expectedGoals: "Gols Esperados", terms: "Termos", privacy: "Privacidade", refund: "Reembolso",
    competitions: "Competicoes", suggestions: "Sugestoes", subscribePremium: "Assinar Premium", subscribePrice: "$9.99/mes",
    selectLeague: "Selecionar Liga", back: "Voltar", live: "AO VIVO",
    watchAd: "Assistir Anuncio para Desbloquear",
    rank: "Pos", team: "Equipe", played: "J", wins: "V", draws: "E", losses: "D", goalDiff: "SG", points: "Pts", form: "Forma",
    homeWinFull: "Vitoria Casa", drawFull: "Empate", awayWinFull: "Vitoria Fora",
    over25Full: "Mais de 2.5 Gols", under25Full: "Menos de 2.5 Gols",
    bttsYes: "Ambas Marcam - Sim", bttsNo: "Ambas Marcam - Nao",
    cornersOver: "Escanteios Mais de", edgeLabel: "Edge", oddLabel: "Odd", probLabel: "Prob",
    stakeLabel: "Aposta", valueBetLabel: "VALUE BET", redFlagLabel: "ALTO RISCO",
    leaguesCat: "Ligas Nacionais", europeCat: "Competicoes Europeias", cupsCat: "Copas Nacionais", internationalCat: "Selecoes",
    matchEvents: "Eventos da Partida", noEvents: "Sem eventos ainda",
    starters: "Titular", substitutes: "Suplentes",
    homeLabel: "Casa", awayLabel: "Fora",
    cornersLabel: "Escanteios", goalsLabel: "Gols", resultLabel: "Resultado", modelLabel: "Modelo",
    home1: "1 - Casa", drawX: "X - Empate", away2: "2 - Fora",
    over85c: "> 8.5 Escanteios", over95c: "> 9.5 Escanteios", over105c: "> 10.5 Escanteios",
  },
  es: {
    appSubtitle: "Analisis Deportivo", navFixtures: "Partidos", navBankroll: "Banca",
    btnRefresh: "Actualizar datos", btnSuggestions: "Sugerencias", btnLogin: "Entrar", btnLogout: "Salir",
    topTips: "Top Tips del Dia", noTips: "Sin tips hoy. Vuelve manana.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets del Dia", noValueBets: "Sin value bets hoy",
    noValueBetsSubtitle: "Vuelve mas tarde o manana", loadingGames: "Cargando partidos...", loading: "Cargando...",
    noGames: "Sin partidos para este dia", noGamesDay: "Sin partidos para este dia",
    result: "Resultado", homeWin: "Victoria Local", draw: "Empate", awayWin: "Victoria Visitante",
    goals: "Goles", over25: "Mas 2.5", under25: "Menos 2.5", btts: "Ambos Marcan", bttsShort: "BTTS Si",
    corners: "Corners", totalExpected: "Total Esperado",
    model: "Modelo", version: "Version", league: "Liga", threshold: "Umbral", bankroll: "Banca",
    marketAnalysis: "Analisis de Mercado", valueBetsSection: "Value Bets", standings: "Clasificacion",
    prediction: "Prediccion", events: "Eventos", statistics: "Estadisticas", lineups: "Alineaciones",
    expectedGoals: "Goles Esperados", terms: "Terminos", privacy: "Privacidad", refund: "Reembolso",
    competitions: "Competiciones", suggestions: "Sugerencias", subscribePremium: "Suscribirse Premium", subscribePrice: "$9.99/mes",
    selectLeague: "Seleccionar Liga", back: "Volver", live: "EN VIVO",
    watchAd: "Ver Anuncio para Desbloquear",
    rank: "Pos", team: "Equipo", played: "J", wins: "V", draws: "E", losses: "D", goalDiff: "DG", points: "Pts", form: "Forma",
    homeWinFull: "Victoria Local", drawFull: "Empate", awayWinFull: "Victoria Visitante",
    over25Full: "Mas de 2.5 Goles", under25Full: "Menos de 2.5 Goles",
    bttsYes: "Ambos Marcan - Si", bttsNo: "Ambos Marcan - No",
    cornersOver: "Corners Mas de", edgeLabel: "Edge", oddLabel: "Cuota", probLabel: "Prob",
    stakeLabel: "Apuesta", valueBetLabel: "VALUE BET", redFlagLabel: "ALTO RIESGO",
    leaguesCat: "Ligas Nacionales", europeCat: "Competiciones Europeas", cupsCat: "Copas Nacionales", internationalCat: "Selecciones",
    matchEvents: "Eventos del Partido", noEvents: "Sin eventos aun",
    starters: "Titulares", substitutes: "Suplentes",
    homeLabel: "Local", awayLabel: "Visitante",
    cornersLabel: "Corners", goalsLabel: "Goles", resultLabel: "Resultado", modelLabel: "Modelo",
    home1: "1 - Local", drawX: "X - Empate", away2: "2 - Visitante",
    over85c: "> 8.5 Corners", over95c: "> 9.5 Corners", over105c: "> 10.5 Corners",
  },
  en: {
    appSubtitle: "Sports Analytics", navFixtures: "Fixtures", navBankroll: "Bankroll",
    btnRefresh: "Refresh data", btnSuggestions: "Feedback", btnLogin: "Login", btnLogout: "Logout",
    topTips: "Top Tips of the Day", noTips: "No high confidence tips today. Come back tomorrow.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets Today", noValueBets: "No value bets for today",
    noValueBetsSubtitle: "Come back later or tomorrow", loadingGames: "Loading fixtures...", loading: "Loading...",
    noGames: "No fixtures for this day", noGamesDay: "No fixtures for this day",
    result: "Result", homeWin: "Home Win", draw: "Draw", awayWin: "Away Win",
    goals: "Goals", over25: "Over 2.5", under25: "Under 2.5", btts: "Both Teams Score", bttsShort: "BTTS Yes",
    corners: "Corners", totalExpected: "Total Expected",
    model: "Model", version: "Version", league: "League", threshold: "Threshold", bankroll: "Bankroll",
    marketAnalysis: "Market Analysis", valueBetsSection: "Value Bets", standings: "Standings",
    prediction: "Prediction", events: "Events", statistics: "Statistics", lineups: "Lineups",
    expectedGoals: "Expected Goals", terms: "Terms", privacy: "Privacy", refund: "Refund",
    competitions: "Competitions", suggestions: "Feedback", subscribePremium: "Subscribe Premium", subscribePrice: "$9.99/month",
    selectLeague: "Select League", back: "Back", live: "LIVE",
    watchAd: "Watch Ad to Unlock",
    rank: "Pos", team: "Team", played: "P", wins: "W", draws: "D", losses: "L", goalDiff: "GD", points: "Pts", form: "Form",
    homeWinFull: "Home Win", drawFull: "Draw", awayWinFull: "Away Win",
    over25Full: "Over 2.5 Goals", under25Full: "Under 2.5 Goals",
    bttsYes: "Both Teams Score - Yes", bttsNo: "Both Teams Score - No",
    cornersOver: "Corners Over", edgeLabel: "Edge", oddLabel: "Odd", probLabel: "Prob",
    stakeLabel: "Stake", valueBetLabel: "VALUE BET", redFlagLabel: "HIGH RISK",
    leaguesCat: "National Leagues", europeCat: "European Competitions", cupsCat: "National Cups", internationalCat: "International",
    matchEvents: "Match Events", noEvents: "No events yet",
    starters: "Starters", substitutes: "Substitutes",
    homeLabel: "Home", awayLabel: "Away",
    cornersLabel: "Corners", goalsLabel: "Goals", resultLabel: "Result", modelLabel: "Model",
    home1: "1 - Home", drawX: "X - Draw", away2: "2 - Away",
    over85c: "> 8.5 Corners", over95c: "> 9.5 Corners", over105c: "> 10.5 Corners",
  },
  fr: {
    appSubtitle: "Analyse Sportive", navFixtures: "Matchs", navBankroll: "Bankroll",
    btnRefresh: "Actualiser", btnSuggestions: "Suggestions", btnLogin: "Connexion", btnLogout: "Deconnexion",
    topTips: "Top Tips du Jour", noTips: "Pas de tips aujourd'hui. Revenez demain.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets du Jour", noValueBets: "Pas de value bets aujourd'hui",
    noValueBetsSubtitle: "Revenez plus tard ou demain", loadingGames: "Chargement des matchs...", loading: "Chargement...",
    noGames: "Pas de matchs pour ce jour", noGamesDay: "Pas de matchs pour ce jour",
    result: "Resultat", homeWin: "Victoire Domicile", draw: "Match Nul", awayWin: "Victoire Exterieur",
    goals: "Buts", over25: "Plus 2.5", under25: "Moins 2.5", btts: "Les deux equipes marquent", bttsShort: "BTTS Oui",
    corners: "Corners", totalExpected: "Total Attendu",
    model: "Modele", version: "Version", league: "Ligue", threshold: "Seuil", bankroll: "Bankroll",
    marketAnalysis: "Analyse de Marche", valueBetsSection: "Value Bets", standings: "Classement",
    prediction: "Prediction", events: "Evenements", statistics: "Statistiques", lineups: "Compositions",
    expectedGoals: "Buts Attendus", terms: "Conditions", privacy: "Confidentialite", refund: "Remboursement",
    competitions: "Competitions", suggestions: "Suggestions", subscribePremium: "S'abonner Premium", subscribePrice: "$9.99/mois",
    selectLeague: "Selectionner Ligue", back: "Retour", live: "EN DIRECT",
    watchAd: "Voir Pub pour Debloquer",
    rank: "Pos", team: "Equipe", played: "J", wins: "V", draws: "N", losses: "D", goalDiff: "DB", points: "Pts", form: "Forme",
    homeWinFull: "Victoire Domicile", drawFull: "Match Nul", awayWinFull: "Victoire Exterieur",
    over25Full: "Plus de 2.5 Buts", under25Full: "Moins de 2.5 Buts",
    bttsYes: "Les deux marquent - Oui", bttsNo: "Les deux marquent - Non",
    cornersOver: "Corners Plus de", edgeLabel: "Edge", oddLabel: "Cote", probLabel: "Prob",
    stakeLabel: "Mise", valueBetLabel: "VALUE BET", redFlagLabel: "RISQUE ELEVE",
    leaguesCat: "Ligues Nationales", europeCat: "Competitions Europeennes", cupsCat: "Coupes Nationales", internationalCat: "Selections",
    matchEvents: "Evenements du Match", noEvents: "Pas d'evenements",
    starters: "Titulaires", substitutes: "Remplacants",
    homeLabel: "Domicile", awayLabel: "Exterieur",
    cornersLabel: "Corners", goalsLabel: "Buts", resultLabel: "Resultat", modelLabel: "Modele",
    home1: "1 - Domicile", drawX: "X - Nul", away2: "2 - Exterieur",
    over85c: "> 8.5 Corners", over95c: "> 9.5 Corners", over105c: "> 10.5 Corners",
  },
  it: {
    appSubtitle: "Analisi Sportiva", navFixtures: "Partite", navBankroll: "Bankroll",
    btnRefresh: "Aggiorna dati", btnSuggestions: "Suggerimenti", btnLogin: "Accedi", btnLogout: "Esci",
    topTips: "Top Tips del Giorno", noTips: "Nessun tip oggi. Torna domani.",
    valueBets: "Value Bets", valueBetsDay: "Value Bets di Oggi", noValueBets: "Nessun value bet oggi",
    noValueBetsSubtitle: "Torna piu tardi o domani", loadingGames: "Caricamento partite...", loading: "Caricamento...",
    noGames: "Nessuna partita per questo giorno", noGamesDay: "Nessuna partita per questo giorno",
    result: "Risultato", homeWin: "Vittoria Casa", draw: "Pareggio", awayWin: "Vittoria Ospite",
    goals: "Gol", over25: "Piu 2.5", under25: "Meno 2.5", btts: "Entrambe Segnano", bttsShort: "BTTS Si",
    corners: "Angoli", totalExpected: "Totale Atteso",
    model: "Modello", version: "Versione", league: "Lega", threshold: "Soglia", bankroll: "Bankroll",
    marketAnalysis: "Analisi di Mercato", valueBetsSection: "Value Bets", standings: "Classifica",
    prediction: "Previsione", events: "Eventi", statistics: "Statistiche", lineups: "Formazioni",
    expectedGoals: "Gol Attesi", terms: "Termini", privacy: "Privacy", refund: "Rimborso",
    competitions: "Competizioni", suggestions: "Suggerimenti", subscribePremium: "Abbonati Premium", subscribePrice: "$9.99/mese",
    selectLeague: "Seleziona Lega", back: "Indietro", live: "IN DIRETTA",
    watchAd: "Guarda Pub per Sbloccare",
    rank: "Pos", team: "Squadra", played: "G", wins: "V", draws: "P", losses: "S", goalDiff: "DR", points: "Pts", form: "Forma",
    homeWinFull: "Vittoria Casa", drawFull: "Pareggio", awayWinFull: "Vittoria Ospite",
    over25Full: "Piu di 2.5 Gol", under25Full: "Meno di 2.5 Gol",
    bttsYes: "Entrambe Segnano - Si", bttsNo: "Entrambe Segnano - No",
    cornersOver: "Angoli Piu di", edgeLabel: "Edge", oddLabel: "Quota", probLabel: "Prob",
    stakeLabel: "Puntata", valueBetLabel: "VALUE BET", redFlagLabel: "ALTO RISCHIO",
    leaguesCat: "Leghe Nazionali", europeCat: "Competizioni Europee", cupsCat: "Coppe Nazionali", internationalCat: "Nazionali",
    matchEvents: "Eventi della Partita", noEvents: "Nessun evento",
    starters: "Titolari", substitutes: "Sostituti",
    homeLabel: "Casa", awayLabel: "Ospite",
    cornersLabel: "Angoli", goalsLabel: "Gol", resultLabel: "Risultato", modelLabel: "Modello",
    home1: "1 - Casa", drawX: "X - Pareggio", away2: "2 - Ospite",
    over85c: "> 8.5 Angoli", over95c: "> 9.5 Angoli", over105c: "> 10.5 Angoli",
  },
};
 
const LANG_NAMES = { pt: "PT", "pt-BR": "BR", es: "ES", en: "EN", fr: "FR", it: "IT" };
 
function detectLanguage() {
  const stored = localStorage.getItem("betmodel_lang");
  if (stored && translations[stored]) return stored;
  const lang = (navigator.language || "en").toLowerCase();
  if (lang.startsWith("pt-br") || lang === "pt_br") return "pt-BR";
  if (lang.startsWith("pt")) return "pt";
  if (lang.startsWith("es")) return "es";
  if (lang.startsWith("fr")) return "fr";
  if (lang.startsWith("it")) return "it";
  if (lang.startsWith("en")) return "en";
  return "en";
}
 
let currentLang = detectLanguage();
let listeners = [];
 
export function t(key) {
  return translations[currentLang]?.[key] || translations["en"]?.[key] || key;
}
 
export function setLanguage(lang) {
  if (!translations[lang]) return;
  currentLang = lang;
  localStorage.setItem("betmodel_lang", lang);
  listeners.forEach(fn => fn(lang));
}
 
export function getLanguage() { return currentLang; }
export function getLanguages() { return Object.keys(translations); }
export function getLangName(lang) { return LANG_NAMES[lang] || lang; }
 
export function onLanguageChange(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}
 
export function useTranslation() {
  const { useState, useEffect } = require("react");
  const [lang, setLang] = useState(currentLang);
  useEffect(() => { return onLanguageChange(setLang); }, []);
  return { t, lang, setLanguage, getLanguages, getLangName };
}